<template>
  <div class="d-flex justify-content-center">
    <b-row :class="`mt-3 ${has_slug ? 'col-12 col-sm-10' : 'col-12 col-lg-8 col-xl-5'}`">
      <b-col class="col-12 text-center">
        <h1 class="mb-1"> {{ $t('creator.seeCasting') }}</h1>
        <p class="mb-3">{{ $t('creator.recommendPublic') }}</p>
        
        <b-form-radio-group class="cursor-pointer" v-model="casting_call.visibility">
          <b-form-radio class="w-100 text-left" value="public">
            <strong>{{ $t('creator.public') }}</strong>
            <p class="avenir-medium">
              {{ $t('creator.textPublic') }}
            </p>
          </b-form-radio>
          <b-form-radio class="w-100 text-left" value="private">
            <strong>{{ $t('creator.private') }}</strong>
            <p class="avenir-medium">{{ $t('creator.textPrivate') }}</p>
          </b-form-radio>
        </b-form-radio-group>
        <b-col class="col-12 d-flex justify-content-center">
          <b-button variant="blue-button-next-step" class="blue-button-next-step my-2"  @click="save()">{{has_slug ? $t('creator.savePreview') : $t('creator.butonNext')}}</b-button>
        </b-col>
      </b-col>
      <small class="mt-2 w-100 text-center text-muted">{{ $t('creator.defaultPublic') }}</small>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BFormRadioGroup,
  BFormRadio,
} from 'bootstrap-vue';
import utils from '@/libs/utils';
import casting_calls_services from '@/services/casting_calls';

export default {
  name: 'stepVisibility',
  components: {
    BRow,
    BCol,
    BButton,
    BFormRadioGroup,
    BFormRadio,
  },
  data() {
    return {
      text: '',
      profile: {},
      utils,
      steps: null,
      casting_call: {},
      casting_call_uuid: '',
    }
  },
  created() {
    this.getData();
  },
  computed: {
    has_slug() {
      return this.$route.params.slug
    }
  },
  methods: {
    getData() {
      if (this.has_slug) {
        
        this.casting_call = {...this.$route.params.casting_call_data}
        this.casting_call_uuid = this.casting_call.uuid;
      } else {
        this.steps = JSON.parse(localStorage.getItem('steps'));
        this.casting_call_uuid = this.steps.uuid ? this.steps.uuid : this.$route.params.casting_call_uuid
        casting_calls_services.getCastingCall(this.casting_call_uuid).then((response) => {
          this.casting_call = response
        });
      }
    },
    save() {
      const form_data = new FormData();
      form_data.append('visibility', this.casting_call.visibility)
      casting_calls_services.updateCastingCall(this.casting_call_uuid, form_data).then((response) => {
        if (response.status === 'OK' && !this.has_slug) this.$router.push({ name: 'steps_casting_call', params: {step: 'location'}})
        else this.$emit('update_campaign', response.response);
      })
    },
  }
}
</script>
<style scoped>
.avatar-middle-stepper {
  position: absolute;
  top: 7em;
  z-index: 10000;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;
}
</style>